import React from 'react';
import {Radio, Button, Checkbox, Form, message, Drawer, Input,Row, Col } from 'antd';
import {  ArrowRightOutlined } from '@ant-design/icons'
import api from "utils/api";
import utils from "utils";
import SubmitButton from '../Patient/SubmitButton'
import Loader from "Components/Loader";
import { CONSTANTS } from 'utils/constant';

class SosScreening extends React.Component {
    constructor(props) {
        super(props)
        let { appointment_id } = this.props.data || {};
        this.state={appointment_id,
            buttonLoading: true
        }
        this.form=React.createRef()
    }
    #IsObject(obj) {
      return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
    }
    componentDidMount() {
      this.props.formAction(false)
        this.getSosData()
    }

    getSosData() {
      api.get_sos_questions()
      .then(res => {
          let { status, data: { results } } = res.data || {}
          if (status == 200) {
              let data = results && results[0]
              this.setState({
                  question_data:data,
                  isLoading: false,
                  buttonLoading: false
              },()=>{
                  this.getSOSConsultationData()
              })
             
          }
      })
    }

    getSOSConsultationData(){
        let data = {
            app_id: this.state.appointment_id,
            type: "sos",
        }
        api.get_consultation_details(data)
            .then((response) => {
                let tempData={}
               if(response.data.data?.results?.sos[0]?.is_completed && (! this.state.is_sos_form_update))
               {
                this.setState({is_sos_form_update:true})
               }
                Object.entries(response.data.data?.results?.sos[0]).forEach(([key,item])=>{
                   
                    if(typeof(item)==='object'){
                        if(Array.isArray(item.values)){
                          if(!tempData.hasOwnProperty(key)){tempData[key]=[]}
                          item.values.forEach((itemobject,index)=>{
                            itemobject.is_selected?tempData[key].push(index):null
                          })
                        } else {
                          if(!tempData.hasOwnProperty(key)){tempData[key]={}}
                          Object.entries(item.values).forEach(([subkey,subitem])=>{
                            if(!tempData[key].hasOwnProperty(key)){tempData[key][subkey]=[]}
                            subitem.values.forEach((itemobject,index)=>{
                            itemobject.is_selected?tempData[key][subkey].push(index):null
                          })
                        })
                      }
                    }
                })
                    
                    this.form.current?.setFieldsValue(tempData);
                    //this.setState({is_Protective_form_update: true});
            })
            .catch(() => {

            })
    }

    onSubmit(userInputs) {
        this.setState({buttonLoading: true})
      let responseData = {...this.state.question_data}
      Object.entries(this.state.question_data.values).map(([groupItemKey,groupItemValue])=>{
          if(Array.isArray(groupItemValue?.values)){
              groupItemValue.values.map((item,index)=>{
                  if(userInputs?.[groupItemKey]?.includes(index)) {
                      responseData.values[groupItemKey].values[index].is_selected=true
                  }
              })
             
           
              
          }
          else {
          Object.entries(groupItemValue.values).map(([itemKey,itemValue])=>{
              if(Array.isArray(itemValue?.values)){
                  itemValue.values.map((item,index)=>{
                      if(userInputs?.[groupItemKey]?.[itemKey]?.includes(index)) {
                          responseData.values[groupItemKey].values[itemKey].values[index].is_selected=true
                      }
                  })
                  
              }
          })
      }
      })
      Object.keys(userInputs).map((item) => {
        if (this.#IsObject(userInputs[item])) {
          Object.values(userInputs[item]).map((val) => {
            if (val?.length > 0) {
              this.setState({ allow_submit: true })
            }
          })  
        }
        else {  
          if (userInputs?.[item]?.length > 0) {
            this.setState({ allow_submit: true })
          }
        }
      })
        if(this.state.allow_submit){
        api.submit_sos({...this.state.question_data, app_id: this.state.appointment_id, is_completed: true,key:"sos",type:this.props.data.user_type || 'adult' })
            .then(res => {
                this.setState({ is_sos_form_update: true})
                if (res.data?.status == 200) {
                    message.success(res.data?.message, ErrorDuration);
                    this.setState({buttonLoading: false})
                  this.props.formAction(false)
                    // this.props.setDsmDone(this.state.dsmDone)
                }
            })
          }else{
            message.error("Cannot submit empty form!", ErrorDuration)
            this.setState({buttonLoading: false})
            this.props.formAction(false)
          }
    }
    render(){
        return (
            <>
                {this.state.isLoading ? <Loader style={this.props.style || {}} /> : <>
                    <div style={this.props.style || {}} className="dsm-screening-container video-casenotes-consultation-wrapper">
                        {/* {this.state.questions && this.state.questions.length && <> */}
                        {this.state.question_data && <>
                            <div className="static-title" >
                                {/* <p className="question-title" > This screening will be an addendum to Case Sheet and the Clinician will bear in mind the following questions (need not ask) while doing the initial evaluation and he or she will click Yes in the checkbox in case the client reports a positive symptom to the relevant question. </p> */}

                            
                            </div>
                            <Form
                                onFinish={this.onSubmit.bind(this)}
                                ref={this.form}
                                colon={false}
                                labelWrap
                                labelAlign="left"
                                onFieldsChange={()=> this.props.formAction(true)}
                                labelCol={{ span: 10 }}
                                wrapperCol={{ span: 14 }}
                                requiredMark={false}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                  }}
                            >
                                        <div className='group-form-item'>
                                            {
                                                (
                                                    Object.entries(this.state.question_data?.values||{}).map(([FormItemKey,FormItemData])=>
                                                        {
                                                            if(Array.isArray(FormItemData.values)){
                                                                return (
                                                                    <Form.Item
                                                                        name={[FormItemKey]}
                                                                        label={utils.ConvertToPascalCase(FormItemData?.title)}
                                                                        className="radio-form-item"
                                                                    >
                                                                        <Checkbox.Group style={{display:"grid"}} options={FormItemData?.values?.map((option,index) => {
                                                                                return {
                                                                                    label: option.label,
                                                                                    value: index
                                                                                }
                                                                            }
                                                                            )} 
                                                                        />
                                                                    </Form.Item>
                                                                )
                                                            }
                                                            //else if(true){return <span>{JSON.stringify(FormItemData?.title)}</span>}
                                                            // else if(FormItemData?.type=='checkbox'){

                                                            // } 
                                                            else {
                                                                return (
                                                                <div className="nested-form-item" style={{borderBottom: "1px solid #E4E4E4"}}>
                                                                <div className="question-title" style={{textDecoration: "underline", paddingLeft: "10px" }}>
                                                                    {
                                                                        FormItemData?.title
                                                                    }
                                                                </div>
                                                                    {Object.entries(FormItemData?.values||{}).map(([nestedFormItemKey,nestedFormItemData])=>
                                                                    {
                                                                        if(Array.isArray(nestedFormItemData.values)){
                                                                            return (
                                                                                <Form.Item
                                                                                    name={[FormItemKey,nestedFormItemKey]}
                                                                                    label={utils.ConvertToPascalCase(nestedFormItemData?.label)}
                                                                                    className="radio-form-item"
                                                                                >
                                                                                    <Checkbox.Group style={{display:"grid"}} options={nestedFormItemData?.values?.map((option,index) => {
                                                                                            return {
                                                                                                label: option.label,
                                                                                                value: index
                                                                                            }
                                                                                        }
                                                                                        )} 
                                                                                    />
                                                                                </Form.Item>
                                                                            )
                                                                        }
                                                                    }
                                                                    )}
                                                                    </div>)
                                                            }
                                                        }
                                                    )
                                                )
                                            }
                                        </div>
                            </Form>
                            <div className="submit-button-wrapper">
                                <SubmitButton className={'common-btn'} onClick={e => this.form.current?.submit()} label={this.state.is_sos_form_update ? `${CONSTANTS.UPDATE}`: `${CONSTANTS.SUBMIT}`} loading={this.state.buttonLoading}/>
                                {/* <Button className='common-btn'  onClick={e => this.form.current?.submit()}>{this.state.is_sos_form_update ?"Update":"Submit"} <ArrowRightOutlined /></Button> */}
                            </div>
                        </> || null}
                    </div>
                </>}
            </>
        )
    }
}

export default SosScreening;